async function waitForNostojs() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (typeof nostojs !== "undefined") {
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
}

async function fetchSessionParams() {
  await waitForNostojs();
  return new Promise((resolve) => {
    nostojs((api) => {
      api.getSearchSessionParams().then((response) => {
        resolve(response);
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", async function () {
  const body = document.querySelector("html");
  const searchInput = document.querySelectorAll(".search__input");
  const mobileInput = document.getElementById("mobile-search");
  const desktopInput = document.getElementById("nosto-search");
  const searchResults = document.querySelector(".search-results");
  const searchContainer = document.querySelector(".nosto-search-container");
  const autocompleteResults = document.querySelector(".autocomplete");
  const searchBar = document.querySelector(".nosto-search-bar");
  const closeButton = document.querySelector(".nosto-close");
  const closeButtonDesktop = document.querySelector(".nosto-close-desktop");
  const backdrop = document.querySelector(".nosto-search-backdrop");
  const storeCurrencyGlobalSetting = '$';
  const accountId = "shopify-29979866";

  const sessionParams = await fetchSessionParams();
  const sessionParamsString = JSON.stringify(sessionParams).replace(
    /"([^"]+)":/g,
    "$1:",
  );

  // Toggle search bar (left icon)
  document
    .querySelector(".site-search-left")
    ?.addEventListener("click", function () {
      if (
        searchBar.style.display === "none" ||
        searchBar.style.display === ""
      ) {
        searchBar.style.display = "block";

        var headWrap = document.querySelector(".template-index #HeaderWrapper");
        headWrap?.classList.remove("is-light");

        var headWrapWidth = document.querySelector(
          ".template-index #HeaderWrapper .page-width",
        );
        if (headWrapWidth) headWrapWidth.style.backgroundColor = "white";

        var searchBarNostoMobile = document.querySelector(".nosto-search-bar");
        if (searchBarNostoMobile)
          searchBarNostoMobile.style.backgroundColor = "white";
      } else {
        searchBar.style.display = "none";

        var headWrap2 = document.querySelector(
          ".template-index #HeaderWrapper",
        );
        headWrap2?.classList.add("is-light");

        var headWrapWidth2 = document.querySelector(
          ".template-index #HeaderWrapper .page-width",
        );
        if (headWrapWidth2)
          headWrapWidth2.style.backgroundColor = "transparent";
      }
    });

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Initialize Nosto API
  const nostoApi = await new Promise((resolve) => {
    nostojs((api) => resolve(api));
  });

  // Analytics helpers
  function recordSearch(type, query, searchResult, options) {
    nostoApi.recordSearch(type, query, searchResult, options);
  }
  function recordSearchSubmit(query) {
    nostoApi.recordSearchSubmit(query);
  }
  function recordSearchClick(type, hit) {
    nostoApi.recordSearchClick(type, hit);
  }

  // Enter-submit
  function handleSearchKey(event) {
    if (event.key !== "Enter") return;

    const searchTerm = event.target.value.trim();

    if (!searchTerm.length) {
      event.preventDefault();

      fetchAndRenderPopular();

      return;
    }

    recordSearchSubmit(searchTerm);

    const searchUrl = `/search?q=${encodeURIComponent(searchTerm)}`;
    window.location.href = searchUrl;
  }

  // Autocomplete click
  function handleAutocompleteClick(event) {
    const el = event.target.closest(".autocomplete-suggestion");
    if (!el) return;

    const type = el.dataset.type || "unknown";
    const position = Number(el.dataset.position || 0);

    const queryText = el.dataset.keyword || el.innerText.trim();
    const redirectUrl = (el.dataset.redirect || "").trim();

    const targetUrl =
      redirectUrl.length > 0
        ? redirectUrl
        : `/search?q=${encodeURIComponent(queryText)}`;

    recordSearchClick("autocomplete", {
      url: targetUrl,
      type,
      query: queryText,
      position,
    });

    window.location.href = targetUrl;
  }

  // Render autocomplete (keywords + popular)
  function renderAutocompleteResults({ keywords = [], popular = [] } = {}) {
    const hasKeywords = Array.isArray(keywords) && keywords.length > 0;
    const hasPopular = Array.isArray(popular) && popular.length > 0;

    if (!hasKeywords && !hasPopular) {
      autocompleteResults.innerHTML = "";
      autocompleteResults.style.display = "none";
      return;
    }

    let html = "";

    if (hasPopular) {
      const filteredPopularSearches = [...popular]
        .filter(
          (popularSearch) =>
            typeof popularSearch.query === "string" &&
            popularSearch.query.trim().length > 1,
        )
        .slice(0, 6);
      html += "<h4>POPULAR SEARCHES</h4>";
      filteredPopularSearches.forEach((item, index) => {
        const label = item?.query || "";
        const redirectUrl = `/search?q=${encodeURIComponent(label)}` || "";

        if (index === filteredPopularSearches.length - 1) {
          html += `
            <a 
            href="${redirectUrl}"
              class="autocomplete-suggestion"
              data-type="popular"
              data-keyword="${label}"
              data-querytext="${label}"
              data-redirect="${redirectUrl}"
              data-position="${index}"
              role="button"
              tabindex="0"
              style="margin-bottom: 15px; cursor: pointer;"
            >
              ${label}
            </a>
          `;
        } else {
          html += `
            <a 
            href="${redirectUrl}"
              class="autocomplete-suggestion"
              data-type="popular"
              data-keyword="${label}"
              data-querytext="${label}"
              data-redirect="${redirectUrl}"
              data-position="${index}"
              role="button"
              tabindex="0"
              style="cursor: pointer;"
            >
              ${label}
            </a>
          `;
        }
      });
    }

    if (hasKeywords) {
      html += "<h4>SEARCH SUGGESTIONS</h4>";
      keywords.forEach((item, index) => {
        const label = item?._highlight?.keyword || item?.keyword || "";
        const keyword = item?.keyword || "";
        const redirectUrl = `/search?q=${encodeURIComponent(label)}` || "";

        if (index === keywords.length - 1) {
          html += `
            <a  
            href="${redirectUrl}"
              class="autocomplete-suggestion"
              data-type="keyword"
              data-keyword="${keyword}"
              data-redirect="${redirectUrl}"
              data-position="${index}"
              style="margin-bottom: 15px"
            >
              ${label}
            </a>
          `;
        } else {
          html += `
            <a 
             href="${redirectUrl}"
              class="autocomplete-suggestion"
              data-type="keyword"
              data-keyword="${keyword}"
              data-redirect="${redirectUrl}"
              data-position="${index}"
            >
              ${label}
            </a>
          `;
        }
      });
    }

    autocompleteResults.innerHTML = html;
    autocompleteResults.style.display = "flex";
    searchContainer.style.display = "flex";

    // Ensure click handlers (click + Enter for accessibility)
    const autocompleteSuggestions = document.querySelectorAll(
      ".autocomplete-suggestion",
    );
    autocompleteSuggestions.forEach((suggestion) => {
      suggestion.addEventListener("click", handleAutocompleteClick);
      suggestion.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleAutocompleteClick({ target: suggestion });
        }
      });
    });
  }

  // -------------- NEW: Fetch + render popular searches on focus (empty query) --------------
  async function fetchAndRenderPopular() {
    backdrop.style.display = "block";
    closeButtonDesktop.style.display = "block";

    try {
      const response = await fetch("https://search.nosto.com/v1/graphql", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          query: `
            query ($query: String) {
              search(
                accountId: "${accountId}",
                sessionParams: ${sessionParamsString},
                query: $query,
                products: { size: 0 },
                keywords: { size: 0, emptyQueryMatchesAll: true },
                popularSearches: { size: 12, emptyQueryMatchesAll: true }
              ) {
                popularSearches {
                  hits {
                    query
                  }
                }
              }
            }
          `,
          variables: { query: "" },
        }),
      });

      const result = await response.json();
      const popular = result?.data?.search?.popularSearches?.hits || [];

      // Visa autocomplete även om sökfältet är tomt
      renderAutocompleteResults({ keywords: [], popular });
    } catch (e) {
      console.error("[popular searches] Error:", e);
    }
  }

  // Bind events: Enter submit + focus popular
  searchInput.forEach((input) => {
    input.addEventListener("keyup", handleSearchKey);

    input.addEventListener("focus", async () => {
      const val = (input.value || "").trim();
      if (!val.length) {
        await fetchAndRenderPopular();
      } else {
        backdrop.style.display = "block";
        closeButtonDesktop.style.display = "block";
      }
    });
  });

  // Search input: debounced typing → query Nosto Search API
  searchInput.forEach((input) => {
    input.addEventListener(
      "input",
      debounce(async function (event) {
        backdrop.style.display = "block";
        closeButtonDesktop.style.display = "block";

        const searchQuery = event.target.value.trim();
        if (searchQuery.length === 0) {
          // Empty: hide products + show popular searches instead
          searchResults.style.display = "none";
          searchResults.innerHTML = "";

          // show popular searches on empty
          await fetchAndRenderPopular();
          return;
        }

        // Record autocomplete input
        recordSearch(
          "autocomplete",
          { query: searchQuery },
          {},
          { isKeyword: false },
        );

        try {
          const response = await fetch("https://search.nosto.com/v1/graphql", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              query: `
                query ($query: String) {
                  search(
                    accountId: "${accountId}",
                    sessionParams: ${sessionParamsString},
                    query: $query,
                    products: { size: 6 },
                    keywords: { size: 6, emptyQueryMatchesAll: true },
                    popularSearches: { 
                      size: 6,
                      emptyQueryMatchesAll: true
                    }
                  ) {
                    products {
                      hits {
                        productId
                        categoryIds
                        name
                        datePublished
                        url
                        imageUrl
                        alternateImageUrls
                        price
                        listPrice
                        priceCurrencyCode
                        reviewCount
                        tags1
                        customFields {
                          key
                          value
                        }
                        skus {
                          name
                          price
                          url
                          availability
                          id
                          customFields {
                            key 
                            value
                          }
                        }
                      }
                      total
                    }
                    keywords {
                      hits {
                        keyword
                        _redirect
                        _highlight {
                          keyword
                        }
                      }
                    }
                    popularSearches {
                      hits {
                        query
                      }
                    }
                  }
                }
              `,
              variables: {
                query: searchQuery,
              },
            }),
          });

          const result = await response.json();

          // Record search results
          recordSearch(
            "serp",
            {
              query: searchQuery,
              products: {
                sort: [],
                filter: [],
              },
            },
            {
              products: {
                hits: (result?.data?.search?.products?.hits || []).map(
                  (hit) => ({ productId: hit.productId }),
                ),
                fuzzy: false,
                total: result?.data?.search?.products?.total || 0,
                size: (result?.data?.search?.products?.hits || []).length,
                from: 0,
              },
            },
          );

          renderSearchResults(result?.data?.search?.products?.hits || []);

          renderAutocompleteResults({
            keywords: result?.data?.search?.keywords?.hits || [],
            popular: result?.data?.search?.popularSearches?.hits || [],
          });
        } catch (error) {
          console.error("Error:", error);
        }
      }, 250),
    );
  });

  // ------------------ BADGES ------------------
  function renderBadges(productElement, product, excludeTags) {
    const badgesContainer = productElement.querySelector(
      ".replace-badges-search",
    );
    if (!badgesContainer || badgesContainer.innerHTML.trim() === "") return;

    const badgesDiv = badgesContainer.previousElementSibling;
    if (!badgesDiv) return;

    const content = badgesContainer.textContent.trim();
    try {
      let parsedContent = JSON.parse(content);

      const storeBadges = document.querySelectorAll(".store-badges .badge");
      const badgeMap = {};

      // Map store badges
      storeBadges.forEach((badge) => {
        const badgeId = badge.getAttribute("data-badge-id");
        badgeMap[badgeId] = badge.outerHTML;
      });

      parsedContent.forEach((id) => {
        let newContent = badgeMap[id] || id;
        const newElement = document.createElement("div");
        newElement.innerHTML = newContent;

        const badgeIdNumericPart = id.split("/").pop();
        if (excludeTags.includes(badgeIdNumericPart)) {
          newElement.style.display = "none";
        }

        badgesDiv.appendChild(newElement);
      });

      // z-index grouping
      const badges = badgesDiv.querySelectorAll(".badge");
      const badgeGroups = {};

      badges.forEach((badge) => {
        const groupClass = Array.from(badge.classList).find((cls) =>
          cls.match(/^q-\d+-p-\d+$/),
        );
        if (groupClass) {
          if (!badgeGroups[groupClass]) badgeGroups[groupClass] = [];
          badgeGroups[groupClass].push(badge);
        }
      });

      let zIndex = 100;
      Object.entries(badgeGroups).forEach(([, group]) => {
        group.forEach((badge) => {
          badge.style.zIndex = zIndex;
        });
        zIndex--;
      });
    } catch (error) {
      console.error("[renderBadges] Error details:", {
        message: error.message,
        stack: error.stack,
        content: content,
      });
    }
  }

  // ------------------ SEARCH RESULTS RENDER ------------------
  function renderSearchResults(results) {
    if (!results || results.length === 0) {
      searchResults.style.display = "none";
      searchResults.innerHTML = "";
      return;
    }

    let html = "";

    results.forEach((product) => {
      const formattedPrice = Number(product.price || 0).toFixed(2);
      const formattedListPrice = Number(product.listPrice || 0).toFixed(2);

      const lowest30dPriceField = product?.skus?.[0]?.customFields?.find(
        (field) => field.key === "frykland_pricehistory-lowest",
      );
      let lowest30dPriceAmount = null;

      const productTitleCustom = product?.url?.split("/products/")?.[1] || "";

      if (lowest30dPriceField) {
        try {
          const lowest30dPrice = JSON.parse(lowest30dPriceField.value);
          lowest30dPriceAmount = parseFloat(lowest30dPrice.amount).toFixed(2);
        } catch (e) {
          lowest30dPriceAmount = null;
        }
      }

      const reviewsRatingField = product.customFields?.find(
        (field) => field.key === "reviews-rating",
      );
      const reviewsRating = reviewsRatingField
        ? JSON.parse(reviewsRatingField.value).value
        : null;

      const hasBundleTag =
        Array.isArray(product.tags1) && product.tags1.includes("bundle");

      // badges
      const customBadgesField = product.customFields?.find(
        (field) => field.key === "custom-badges",
      );
      let badgeData = "[]";
      if (customBadgesField) badgeData = customBadgesField.value;

      const wcategories = product?.categoryIds || [];
      const discountBoxes = document.querySelector(
        ".logged-in-discounts-box-overview-page",
      );
      let bestDiscount = null;

      if (Array.isArray(wcategories) && discountBoxes) {
        let i = 1;
        while (true) {
          const idsSpan = discountBoxes.querySelector(`.discount-ids-${i}`);
          const percentageSpan = discountBoxes.querySelector(
            `.discount-percentage-${i}`,
          );
          const titleSpan = discountBoxes.querySelector(`.discount-title-${i}`);
          if (!idsSpan || !percentageSpan || !titleSpan) break;

          const discountIds = idsSpan.innerText
            .split(",")
            .map((id) => id.trim());
          const matchFound = wcategories.some((catId) =>
            discountIds.includes(String(catId)),
          );

          if (matchFound) {
            const percentage = parseFloat(percentageSpan.innerText.trim());
            if (!bestDiscount || percentage > bestDiscount.percentage) {
              bestDiscount = {
                discountIdGroup: i,
                percentage,
                title: titleSpan.innerText.trim(),
                ids: discountIds,
              };
            }
          }
          i++;
        }
      }

      const discountHTML = bestDiscount
        ? `<div class="nosto-discount-banner"> ${bestDiscount.title} </div>`
        : "";

      const discountPercentage = bestDiscount?.percentage ?? 0;
      const discountedPriceLoggedIn =
        (product.price * discountPercentage) / 100;
      const newPriceLoggedInF = formattedListPrice - discountedPriceLoggedIn;
      const newPriceLoggedIn = Number(newPriceLoggedInF).toFixed(2);

      const reviewsRatingCountField = product.customFields?.find(
        (field) => field.key === "reviews-rating_count",
      );
      const reviewsRatingCount = reviewsRatingCountField
        ? reviewsRatingCountField.value
        : 0;

      const productColorVariantsField = product.customFields?.find(
        (field) => field.key === "product-color_variants",
      );
      const productColorVariants = productColorVariantsField
        ? productColorVariantsField.value
        : "";
      const productColorVariantsCount = productColorVariants
        ? productColorVariants.split("|").length - 1
        : 0;

      const pricedif =
        lowest30dPriceAmount !== null
          ? lowest30dPriceAmount - product.price
          : 0;

      let discountPercentageC = "";
      if (lowest30dPriceAmount == null) {
        if (product.listPrice > product.price) {
          const discount =
            ((product.listPrice - product.price) / product.listPrice) * 100;
          discountPercentageC = `-${Math.round(discount)}%`;
        }
      } else {
        if (pricedif > 1 && lowest30dPriceAmount > product.price) {
          const discount =
            ((lowest30dPriceAmount - product.price) / lowest30dPriceAmount) *
            100;
          discountPercentageC = `-${Math.round(discount)}%`;
        }
      }

      html += `
<div class="search-result nosto-product-info product-search-bundle-${hasBundleTag}" data-product-handle="${productTitleCustom}" data-variant-id="${product?.skus?.[0]?.id || ""}" data-product-url="${product.url}" data-product-id="${product.productId}" data-product-image-url="${product.imageUrl}">
  <div class="top-container">
    <a href="${product.url}">
      <div class="nosto-product-images"> 
        <img src="${product.imageUrl}" alt="${product.name}" class="search-result__image"> 
        <div class="badges-wrapper"></div>
        <div class="replace-badges-search" style="display:none;">${badgeData}</div>
      </div>
    </a>

    <div class="wishlist-new-pdp">
      <button class="grid-product__action wishlist flip-animation" type="button" data-button-action="wishlist" data-empi="${product.productId}">
        <div class="front-side">
          <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
            <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
              <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="none" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            </g>
          </svg>
          <span class="icon__fallback-text">Add To Wishlist</span>
        </div>
        <div class="back-side" aria-hidden="true">
          <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
            <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
              <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            </g>
          </svg>
          <span class="icon__fallback-text">Remove From Wishlist</span>
        </div>
      </button>
    </div>
  </div>

  <div class="bottom-container">
    <a class="pdp-name-bottom-container" href="${product.url}">
      <span class="search-result__name">${product.name}</span>
    </a>

    <div class="nosto-bottom-bar">
      <a href="${product.url}">
        <div class="price-container-nosto-api ${
          product.price >= product.listPrice && discountHTML
            ? " price-container-nosto-api-logged-in-discounts "
            : ""
        }">
          <span ${
            product.price >= product.listPrice && discountHTML
              ? ' class="search-result__price money grid-product__price price" '
              : ""
          } style="${
            product.price >= product.listPrice && discountHTML
              ? "color: #c1132c ;font-weight: 500;line-height: 14.4px; padding-right:1px;"
              : "display:none;"
          }"> ${newPriceLoggedIn} ${storeCurrencyGlobalSetting} </span>

          <span class="search-result__price money grid-product__price price" style="${
            product.listPrice > product.price
              ? "color: #c1132c ;font-weight: 500;"
              : ""
          } ${
            product.price >= product.listPrice && discountHTML
              ? "text-decoration: line-through;color: black;padding-left:4px;"
              : ""
          }">${formattedPrice} ${storeCurrencyGlobalSetting} </span>

          <span class="header-disc" style="${
            product.price >= product.listPrice && discountHTML
              ? "font-weight: 500;font-size:12px;line-height: 14.4px;"
              : "display:none;"
          }">${discountHTML} </span>

          <span class="search-result__price money grid-product__price price-compare-nosto" style="${
            lowest30dPriceAmount == null && product.listPrice > product.price
              ? "color: black;text-decoration: line-through;display:block;"
              : "display:none;"
          }">${formattedListPrice} ${storeCurrencyGlobalSetting}</span>

          <span class="search-result__price money grid-product__price price-compare-nosto app-price" style="${
            lowest30dPriceAmount !== null &&
            pricedif > 1 &&
            lowest30dPriceAmount > product.price
              ? "color: black;text-decoration: line-through;display:block;"
              : "display:none;"
          }">${lowest30dPriceAmount} ${storeCurrencyGlobalSetting}</span>

          <div class="custom-tooltip-notice" style="${
            lowest30dPriceAmount !== null &&
            pricedif > 1 &&
            lowest30dPriceAmount >= product.price &&
            lowest30dPriceAmount !== formattedListPrice
              ? "display:flex;"
              : "display:none;"
          }"> 
            <div class="tooltip-content"> 
              <p> Strikethrough price is the lowest price the last 30 days. </p>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info tooltip-btn" style="width: 15px;margin-right:5px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
          </div>

          <span class="sale-perc-s-h" style="${discountPercentageC ? "" : "display:none;"}">${discountPercentageC}</span>
        </div>
      </a>

      <div data-product-handle="${productTitleCustom}" class="mobile-atc-size-drawer" aria-label="Add to cart">
        <span>+</span>
      </div>
    </div>

    <div class="product-extra-data"> 
      <a href="${product.url}" style="${productColorVariantsCount > 0 ? "" : "display:none;"} ">
        <span> Colors +${productColorVariantsCount}</span>
      </a>
      <a href="${product.url}">
        <span style="${reviewsRating == null ? "display:none;" : ""}"> ★ ${reviewsRating} (${reviewsRatingCount}) </span>
      </a>
    </div>

    <div class="sku-container-new">
      <span class="sku-new-add-to-cart-sign">Add to cart </span>
      <div class="sku-list-new">
        ${(product.skus || [])
          .filter((sku) => sku.price > 0)
          .map(
            (sku) => `
              <div data-variant-id="${sku.id}" class="${sku.price} sku-item ${sku.availability === "OutOfStock" ? "unavailable" : ""}">
                <span class="sku-name">${sku.name}</span>
              </div>
            `,
          )
          .join("")}
      </div>
    </div>
  </div>
</div>
`;
    });

    searchResults.innerHTML = html;
    searchResults.style.display = "flex";
    searchContainer.style.display = "flex";

    attachEventListenersToButtons();

    // Render badges
    const excludeTags = ["tag-to-exclude"];
    document
      .querySelectorAll(".nosto-product-info")
      .forEach((productElement, index) => {
        const currentProduct = results[index];
        renderBadges(productElement, currentProduct, excludeTags);
      });

    function reinitializeQuickShopSliders() {
      setTimeout(() => {
        const quickShopColorVariantSliders = document.querySelectorAll(
          ".quickshop .product-single__color-variants",
        );
        quickShopColorVariantSliders.forEach((slider) => {
          const colorVariantItems = slider.querySelectorAll(
            ".quickshop .product-single__color-variant",
          );
          if (colorVariantItems.length > 4) {
            const qsflickityInstance = Flickity.data(slider);
            if (qsflickityInstance) qsflickityInstance.destroy();
            new Flickity(slider, {
              cellAlign: "left",
              contain: true,
              pageDots: false,
              prevNextButtons: true,
              draggable: true,
            });
          }
        });

        const quickShopSlideshowSliders = document.querySelectorAll(
          ".quickshop .product-slideshow",
        );
        quickShopSlideshowSliders.forEach((slider) => {
          const qsmainflickityInstance = Flickity.data(slider);
          if (qsmainflickityInstance) qsmainflickityInstance.destroy();
          new Flickity(slider, {
            cellAlign: "left",
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
          });
        });
      }, 300);
    }

    document.querySelectorAll(".mobile-atc-size-drawer").forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();

        const drawer = document.getElementById("quickshop");
        drawer?.classList.add("open");

        const productHandle = button.getAttribute("data-product-handle");
        if (!productHandle) {
          console.error("Product handle not found.");
          return;
        }

        try {
          const response = await fetch(`/products/${productHandle}?view=ajax`);
          if (!response.ok) throw new Error("Failed to fetch product page.");

          const productHTML = await response.text();
          const drawerContent = document.querySelector(".quickshop");

          if (drawerContent) {
            const headerHTML = `
              <div class="quickshop-header">
                <div class="drawer__close">
                  <button type="button" class="drawer__close-button js-drawer-close">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="19.799" height="19.799" viewBox="0 0 19.799 19.799">
                      <g id="Group_4" data-name="Group 4" transform="translate(0.707 0.707)">
                        <line id="Line_1" data-name="Line 1" x2="26" transform="translate(0 0) rotate(45)" fill="none" stroke="#222" stroke-width="2"/>
                        <line id="Line_2" data-name="Line 2" x2="26" transform="translate(0 18.385) rotate(-45)" fill="none" stroke="#222" stroke-width="2"/>
                      </g>
                    </svg>
                    <span class="icon__fallback-text">{{ 'cart.general.close_cart' | t }}</span>
                  </button>
                </div>
                <div class="h1 site-header__logo" itemscope="" itemtype="http://schema.org/Organization" aria-label="to homepage">
                  <a href="/" itemprop="url" class="site-header__logo-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="98.439" height="26" viewBox="0 0 404.29 98.61"><polygon points="95.05 8.05 112.93 8.05 112.93 98.44 95.05 98.22 95.05 8.05" fill="currentColor"></polygon><path d="M336.18,243h17.93v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86s10.6-17.86,36.25-17.86c37.4,0,43.08,35.8,43.08,36.89v53.66H479l0-49.62s-.95-22.95-26-22.9c-24.85,0-27.52,22.9-27.52,22.9v49.61H407.67l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9l-.06,49.62H336.18Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M306.88,243l-.05,90.39h-18v-8s-13.35,9.15-26.26,8c-1.1-.11-43.47,1.11-44.35-47.13C218,245.49,258.12,243,258.12,243Zm-45.12,17.82s-25.49-2.35-25.71,25.51c1.8,29.34,26.81,28.7,26.81,28.7s22.95,1.9,25.91-21.78V260.86Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M501.08,243.1H519v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86a38.24,38.24,0,0,1,8.73,23.07c0,1.76,0,49.61,0,49.61H572.57l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9L519,333.48H501.08Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M495.61,235l-16.31,0,0,8.81a39.37,39.37,0,0,1,8.22,7.26c1.49,1.82,2.34,1.43,8.07,12.58Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M591.18,258.69c0-9.11,6.49-15.76,15.68-15.76s15.6,6.65,15.6,15.76-6.49,15.83-15.6,15.83S591.18,267.8,591.18,258.69Zm4.31,0c0,6.85,4.38,11.65,11.3,11.65s11.37-4.8,11.37-11.65S613.64,247,606.79,247,595.49,251.84,595.49,258.69Zm14.69,1.7,4.33,6.41-4.87.08-3.71-6.18h-1.31v6.18h-4v-16.6H608c3.47,0,5.79,2,5.79,5.17A4.92,4.92,0,0,1,610.18,260.39Zm-5.56-6.49v3.48h3.17a1.77,1.77,0,0,0,2-1.78c0-1.23-.93-1.7-2-1.7Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path></svg> 
                  </a>
                </div>
                <div class="drawer__empty-right"></div>
              </div>
            `;
            drawerContent.innerHTML = headerHTML + productHTML;

            reinitializeQuickShopSliders();
            if (window.lipscore?.reInitWidgets) lipscore.reInitWidgets();

            const closeButtonQS = document.querySelector(
              ".quickshop-header .drawer__close-button",
            );
            if (closeButtonQS) {
              closeButtonQS.addEventListener("click", () => {
                const quickshop = document.querySelector(".quickshop");
                if (quickshop) {
                  quickshop.innerHTML = "";
                  quickshop.style.display = "none";
                }
                const existingOverlay =
                  document.querySelector(".quickshop-overlay");
                if (existingOverlay) existingOverlay.remove();
              });
            }

            const overlay = document.createElement("div");
            overlay.className = "quickshop-overlay";
            overlay.style.cssText = `
              width: 100%;
              height: 100%;
              position: fixed;
              background: black;
              left: 50%;
              z-index: 1;
              top: 50%;
              transform: translate(-50%, -50%);
              opacity: 0.3;
            `;
            document.body.appendChild(overlay);

            const closeQuickShop = () => {
              const quickshop = document.querySelector(".quickshop");
              if (quickshop) {
                quickshop.innerHTML = "";
                quickshop.style.display = "none";
              }
              const existingOverlay =
                document.querySelector(".quickshop-overlay");
              if (existingOverlay) existingOverlay.remove();
            };
            overlay.addEventListener("click", closeQuickShop);

            drawerContent.style.display = "flex";

            document
              .querySelectorAll(".quickshop .variant-input")
              .forEach((input) => {
                input.addEventListener("click", () => {
                  document
                    .querySelectorAll(".quickshop .variant-input")
                    .forEach((el) => el.classList.remove("var-inpt-selected"));
                  input.classList.add("var-inpt-selected");
                });
              });

            function updateProductDetails(productUrl) {
              const newTitle = document.querySelector(
                ".quickshop .product-single__title",
              )?.textContent;
              if (newTitle) document.title = newTitle;
              if (typeof initNoDrawerCheckoutCTA === "function")
                initNoDrawerCheckoutCTA();
            }

            function onVariantChange({ target: optionValueElement }) {
              const productElement = document.querySelector(
                ".quickshop .combined-product",
              );
              const sectionNode = document.querySelector(
                ".quickshop #productSection",
              );
              const sectionId = sectionNode?.dataset?.sectionId;

              if (!productElement || !sectionId) return;

              const oldProductUrl = productElement.dataset.productUrl;
              const newProductUrl = optionValueElement.dataset.productUrl;
              const productUrl = newProductUrl ? newProductUrl : oldProductUrl;
              const newVariantId = optionValueElement.dataset.variantId;

              let params = `section_id=${sectionId}&`;

              if (newVariantId) {
                params += `variant=${newVariantId}`;
              } else {
                const selectedOptionValues = Array.from(
                  document.querySelectorAll(
                    ".quickshop fieldset input:checked",
                  ),
                )
                  .map((element) => element.dataset.optionValueId)
                  .join(",");
                params += `option_values=${selectedOptionValues}`;
              }

              document
                .querySelectorAll(".quickshop variant-input")
                .forEach((div) => div.classList.remove("selected"));
              document
                .querySelectorAll('.quickshop input[type="radio"]')
                .forEach((input) => input.classList.remove("selected"));

              optionValueElement.classList.add("selected");
              optionValueElement
                .closest(".variant-input")
                ?.classList.add("selected");

              fetch(`${productUrl}?${params}`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(
                    responseText,
                    "text/html",
                  );

                  if (newProductUrl && oldProductUrl !== newProductUrl) {
                    productElement.parentNode.insertBefore(
                      html.querySelector(".combined-product"),
                      productElement,
                    );
                    productElement.remove();

                    updateProductDetails(newProductUrl);
                    reinitializeQuickShopSliders();

                    document
                      .querySelectorAll(".quickshop .size-selector-button")
                      .forEach(function (button) {
                        button.addEventListener("click", function () {
                          theme?.SizeGuideModal?.open?.();
                        });
                      });

                    document
                      .querySelector(`#${optionValueElement.id}`)
                      ?.focus?.();
                    if (typeof initNoDrawerCheckoutCTA === "function")
                      initNoDrawerCheckoutCTA();
                    return;
                  }

                  const ovs = document.querySelector(
                    ".quickshop .optionValueSelectors",
                  );
                  const ovsNew = html.querySelector(".optionValueSelectors");
                  if (ovs && ovsNew) ovs.innerHTML = ovsNew.innerHTML;

                  document
                    .querySelector(`#${optionValueElement.id}`)
                    ?.focus?.();

                  const priceEl = document.querySelector(
                    ".quickshop .product__price",
                  );
                  const priceNew = html.querySelector(".product__price");
                  if (priceEl)
                    priceEl.innerHTML = priceNew ? priceNew.innerHTML : "";

                  document
                    .querySelectorAll(".quickshop .size-selector-button")
                    .forEach(function (button) {
                      button.addEventListener("click", function () {
                        theme?.SizeGuideModal?.open?.();
                      });
                    });

                  const addToCartForm = document.querySelector(
                    ".quickshop .product-form",
                  );
                  const newVariantInput = html.querySelector(
                    '.product-form input[name="id"]',
                  );
                  if (addToCartForm && newVariantInput) {
                    const hidden =
                      addToCartForm.querySelector('input[name="id"]');
                    if (hidden) hidden.value = newVariantInput.value;
                  }
                });
            }

            document
              .querySelector(".quickshop #productSection")
              ?.addEventListener("change", onVariantChange);

            if (typeof initNoDrawerCheckoutCTA === "function")
              initNoDrawerCheckoutCTA();
          }
        } catch (error) {
          console.error("Error loading product page:", error);
        }
      });
    });
  }

  // Attach wishlist clicks
  function attachEventListenersToButtons() {
    document
      .querySelectorAll(
        ".nosto-search-container .grid-product__action.wishlist",
      )
      .forEach((button) => {
        button.addEventListener("click", handleWishListClick);
      });
  }

  function handleWishListClick(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const wishList = evt.target;
    const product = wishList.closest(".nosto-product-info");
    const wishlistbtn = wishList.closest(".wishlist");
    if (!product) return;

    const wishListObject = {
      epi: product.getAttribute("data-variant-id"),
      du: product.getAttribute("data-product-url"),
      empi: product.getAttribute("data-product-id"),
      iu: product.getAttribute("data-product-image-url"),
    };

    const isSaved = wishList.classList.toggle("is-saved");
    wishlistbtn?.classList.toggle("is-saved");

    const action = isSaved ? "addToWishList" : "removeFromWishList";
    window._swat?.[action]?.(wishListObject, function (r) {
      console.log("wishlist", isSaved ? "added" : "removed", r);
    });
  }

  // Mobile
  function isMobileDevice() {
    return window.innerWidth < 769;
  }
  function addFixedClass() {
    if (isMobileDevice()) {
      searchBar.classList.add("fullscreen-trigger");
      body.style.overflow = "hidden";
      closeButton.classList.add("show");
      searchContainer.classList.add("show");
    }
  }

  if (mobileInput) {
    mobileInput.addEventListener("click", addFixedClass);
    mobileInput.addEventListener("keyup", handleSearchKey);

    // NEW: även på mobile - visa popular på focus/click när tomt
    mobileInput.addEventListener("focus", async () => {
      const val = (mobileInput.value || "").trim();
      if (!val.length) await fetchAndRenderPopular();
    });
  }

  // Backdrop close
  backdrop?.addEventListener("click", function () {
    searchContainer.style.display = "none";
    backdrop.style.display = "none";
    if (desktopInput) desktopInput.value = "";
    searchResults.innerHTML = "";
    autocompleteResults.innerHTML = "";
    closeButtonDesktop.style.display = "none";
  });

  // Close mobile fullscreen
  closeButton?.addEventListener("click", function () {
    closeButton.classList.remove("show");
    searchBar.classList.remove("fullscreen-trigger");
    body.style.overflow = "auto";
    searchBar.style.display = "none";
    if (mobileInput) mobileInput.value = "";
    searchContainer.classList.remove("show");
    searchResults.innerHTML = "";
    autocompleteResults.innerHTML = "";
    searchContainer.style.display = "none";
    backdrop.style.display = "none";

    const headWrap = document.querySelector(".template-index #HeaderWrapper");
    if (headWrap) {
      headWrap.classList.add("is-light");
      const headWrapWidth = headWrap.querySelector(".page-width");
      if (headWrapWidth) headWrapWidth.style.backgroundColor = "transparent";
    }
  });

  // Close desktop
  closeButtonDesktop?.addEventListener("click", function () {
    searchContainer.style.display = "none";
    backdrop.style.display = "none";
    if (desktopInput) desktopInput.value = "";
    searchResults.innerHTML = "";
    autocompleteResults.innerHTML = "";
    closeButtonDesktop.style.display = "none";
  });
});

// -------------------- Din befintliga initNoDrawerCheckoutCTA lämnas oförändrad --------------------
function initNoDrawerCheckoutCTA() {
  (function () {
    const VER =
      "CNV-PDP NoDrawer Checkout CTA v1.6 (Nosto moves after ATC under .under-atc-text)";
    if (window.__cnvNoDrawerCheckoutCTA_v16) {
      console.warn(`[${VER}] already applied`);
      return;
    }
    window.__cnvNoDrawerCheckoutCTA_v16 = true;

    const q = (s, r = document) => r.querySelector(s);
    const qa = (s, r = document) =>
      Array.prototype.slice.call(r.querySelectorAll(s));
    const on = (el, ev, fn, opts) =>
      el && el.addEventListener(ev, fn, opts || false);
    const FORM_SEL =
      '.product-form, .product-single__form, form[action="/cart/add"]';

    (function injectStyle() {
      if (q("#cnv-nodrawer-style")) return;
      const css = `
        #cnv-checkout-cta { display:none; width:100%; clear:both; margin-top:10px; overflow:hidden; transition:max-height .25s ease; }
        #cnv-checkout-cta.cnv-open { display:block; max-height:160px; }
        #cnv-checkout-cta:not(.cnv-open) { max-height:0; }
        #cnv-checkout-cta .cnv-checkout-btn {
          display:block; width:100%; text-align:center;
          background:#000; color:#fff; border:0; border-radius:0px;
          padding:14px 16px; font-weight:600; cursor:pointer; text-decoration:none;
        }
        #cnv-checkout-cta .cnv-checkout-btn:focus { outline:2px solid #111; outline-offset:2px; }
        .cnv-nosto-below-cta { width:100% !important; display:block !important; clear:both !important; }
      `;
      const s = document.createElement("style");
      s.id = "cnv-nodrawer-style";
      s.textContent = css;
      document.head.appendChild(s);
    })();

    function getCheckoutHref() {
      const candidates = [
        '#CartDrawer a[href*="/check"]',
        '.ajaxcart__checkout[href*="/check"]',
        '.mini-cart a[href*="/check"]',
        '.cart__checkout[href*="/check"]',
        'a.btn--checkout[href*="/check"]',
        'a[href^="/checkout"]',
      ];
      for (const sel of candidates) {
        const a = q(sel);
        if (a && a.getAttribute("href")) return a.getAttribute("href");
      }
      return "/cart";
    }

    function ensureCheckoutCTA() {
      const btnWrap = q(".pdp-button-container") || q(FORM_SEL);
      if (!btnWrap) return null;

      let cta = q("#cnv-checkout-cta", btnWrap) || q("#cnv-checkout-cta");
      if (!cta || (cta && cta.parentElement !== btnWrap)) {
        if (cta && cta.parentElement !== btnWrap) {
          btnWrap.appendChild(cta);
        } else if (!cta) {
          cta = document.createElement("div");
          cta.id = "cnv-checkout-cta";
          const a = document.createElement("a");
          a.className = "cnv-checkout-btn";
          a.textContent = "Till kassan";
          a.href = getCheckoutHref();
          a.rel = "nofollow";
          cta.appendChild(a);
          btnWrap.appendChild(cta);
        }
      } else {
        const a = cta.querySelector(".cnv-checkout-btn");
        if (a) a.href = getCheckoutHref();
      }
      return cta;
    }

    function revealCheckoutCTA() {
      const cta = ensureCheckoutCTA();
      if (cta) {
        const a = cta.querySelector(".cnv-checkout-btn");
        if (a) a.href = getCheckoutHref();
        cta.classList.add("cnv-open");
      }
    }

    function getCandidateNostoEls() {
      const ids = [
        "#productpage_nosto_8",
        "#productpage-nosto-8",
        "#productpage-nosto_2",
        "#productpage-nosto_2",
        "#pdp-rec-2",
        "#pdp-rec-1",
        "#pdp-rec-3",
        "#pdp-rec-4",
        "#pdp-rec-5",
        ".nosto_element#productpage_nosto_8",
        ".nosto_element#productpage-nosto-2",
      ];
      const found = ids.map((sel) => q(sel)).filter(Boolean);
      qa(".product-single__meta .nosto_element").forEach((el) => {
        if (!found.includes(el)) found.push(el);
      });
      return found;
    }

    function nostoHasContent(root) {
      if (!root) return false;
      const sel = [
        ".nosto-list-item",
        ".nosto-product",
        ".product, .grid-product, .product-card",
        "img[src], img[data-src], img[data-srcset]",
        'a[href*="/products/"]',
      ].join(",");
      if (root.querySelector(sel)) return true;
      const text = (root.textContent || "").replace(/\s+/g, " ").trim();
      return text.length > 80;
    }

    function moveNostoUnderATCTextWhenReady(timeoutMs = 15000) {
      const underAtc = q(".under-atc-text");
      if (!underAtc) return;
      const nostos = getCandidateNostoEls();
      if (!nostos.length) return;

      const doMove = (el) => {
        if (!el) return;
        el.classList.add("cnv-nosto-below-cta");
        underAtc.insertAdjacentElement("afterend", el);
      };

      const ready = nostos.find((n) => nostoHasContent(n));
      if (ready) {
        doMove(ready);
        return;
      }

      const observers = [];
      const stopAll = () => observers.forEach((o) => o.disconnect());

      nostos.forEach((nosto) => {
        const obs = new MutationObserver(() => {
          if (nostoHasContent(nosto)) {
            stopAll();
            doMove(nosto);
          }
        });
        obs.observe(nosto, { childList: true, subtree: true });
        observers.push(obs);
      });

      setTimeout(stopAll, timeoutMs);
    }

    function getCurrentVariantId(scope = document) {
      let cand =
        scope.querySelector('input[type="radio"][data-variant-id].selected') ||
        scope.querySelector('input[type="radio"][data-variant-id]:checked');
      if (cand && cand.getAttribute("data-variant-id"))
        return cand.getAttribute("data-variant-id");

      const checked = scope.querySelector('input[type="radio"]:checked');
      if (checked) {
        const wrapper = checked.closest(".variant-input");
        if (wrapper && wrapper.getAttribute("data-variant-id"))
          return wrapper.getAttribute("data-variant-id");
      }

      const selWrap = scope.querySelector(".variant-input.selected");
      if (selWrap && selWrap.getAttribute("data-variant-id"))
        return selWrap.getAttribute("data-variant-id");

      const sel = scope.querySelector('select[name="id"]');
      if (sel && sel.value) return sel.value;

      const hidden = scope.querySelector('input[name="id"]');
      if (hidden && hidden.value) return hidden.value;

      return null;
    }

    function syncVariantIdIntoForm(form) {
      if (!form) return null;
      const current =
        getCurrentVariantId(form) || getCurrentVariantId(document);
      if (!current) return null;

      const hidden = form.querySelector('input[name="id"]');
      const select = form.querySelector('select[name="id"]');
      if (hidden && hidden.value !== String(current))
        hidden.value = String(current);
      if (select && select.value !== String(current))
        select.value = String(current);

      return String(current);
    }

    function setATCStateSuccess(form) {
      const atcBtn = form.querySelector(
        '.add-to-cart, .combined-atc-btn, button[name="add"]',
      );
      if (!atcBtn) return;
      const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
      atcBtn.classList.add("cnv-atc-success");
      const original =
        txt.getAttribute("data-default-text") || "Lägg till i varukorgen";
      txt.setAttribute("data-original-text", original);
      txt.textContent = "Tillagd";
    }

    function resetATCState(form) {
      const atcBtn =
        form &&
        form.querySelector(
          '.add-to-cart, .combined-atc-btn, button[name="add"]',
        );
      if (!atcBtn) return;
      atcBtn.classList.remove("cnv-atc-success");
      const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
      const def = (
        txt.getAttribute("data-default-text") ||
        txt.getAttribute("data-original-text") ||
        "Lägg till i varukorgen"
      ).trim();
      txt.textContent = def;
      const cta = ensureCheckoutCTA();
      if (cta) cta.classList.remove("cnv-open");
    }

    function refreshCartQuietly() {
      try {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (!cart) return;
            document.dispatchEvent(
              new CustomEvent("cart:refresh", { detail: { cart } }),
            );
            document.dispatchEvent(
              new CustomEvent("cart:build", { detail: { cart } }),
            );
          })
          .catch(() => {});
      } catch (e) {}
    }

    let guardUntil = 0;
    function armDrawerGuard(ms = 5000) {
      guardUntil = Date.now() + ms;
    }

    const CART_OPEN_SEL = [
      ".js-drawer-open-cart",
      '[data-action="open-drawer"]',
      '[data-drawer="cart"]',
      '[data-drawer-trigger="cart"]',
      ".cart-toggle",
      ".header-cart",
      ".site-header__cart-toggle",
    ].join(",");

    on(
      document,
      "click",
      function (e) {
        const tgt =
          e.target && e.target.closest && e.target.closest(CART_OPEN_SEL);
        if (!tgt) return;
        if (Date.now() < guardUntil) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === "function")
            e.stopImmediatePropagation();
        }
      },
      true,
    );

    on(
      document,
      "submit",
      function (e) {
        const form = e.target;
        if (!form || !form.matches(FORM_SEL)) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function")
          e.stopImmediatePropagation();

        const currentVariantId = syncVariantIdIntoForm(form);
        if (!currentVariantId) return;

        armDrawerGuard(5000);

        const atcBtn = form.querySelector(
          '.add-to-cart, .combined-atc-btn, button[name="add"]',
        );
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.setAttribute("aria-busy", "true");
        }

        const fd = new FormData(form);
        fd.set("id", String(currentVariantId));

        fetch("/cart/add.js", {
          method: "POST",
          body: fd,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        })
          .then((r) => {
            if (!r.ok) throw new Error("Add to cart failed");
            return r.json();
          })
          .then(() => {
            setATCStateSuccess(form);
            revealCheckoutCTA();
            moveNostoUnderATCTextWhenReady();
            refreshCartQuietly();
          })
          .catch((err) => {
            console.error("[NoDrawer] ATC error", err);
          })
          .finally(() => {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.removeAttribute("aria-busy");
            }
          });
      },
      true,
    );

    (function observeProductArea() {
      const root =
        q("#productSection") ||
        q(".combined-product") ||
        q(".product-single__meta") ||
        document.documentElement;
      const mo = new MutationObserver(() => {
        const form = q(FORM_SEL);
        if (form) syncVariantIdIntoForm(form);
        ensureCheckoutCTA();
      });
      mo.observe(root, { childList: true, subtree: true });
    })();

    (function bindVariantReset() {
      const container =
        q("#productSection") || q(".product-single__meta") || document;
      on(
        container,
        "change",
        function (e) {
          if (!e.target) return;
          if (e.target.matches('input[type="radio"], select')) {
            const form = q(FORM_SEL);
            syncVariantIdIntoForm(form);
            resetATCState(form);
            ensureCheckoutCTA();
          }
        },
        true,
      );

      on(document, "variant:change", function () {
        const form = q(FORM_SEL);
        syncVariantIdIntoForm(form);
        resetATCState(form);
        ensureCheckoutCTA();
      });

      on(document, "variantSwitched", function () {
        const form = q(FORM_SEL);
        syncVariantIdIntoForm(form);
        resetATCState(form);
        ensureCheckoutCTA();
      });
    })();

    (function boot() {
      const form = q(FORM_SEL);
      if (form) syncVariantIdIntoForm(form);
      ensureCheckoutCTA();
    })();
  })();
}
